export { localStorage } from '@apparel/core/storage';
